module.exports = __webpack_public_path__ + "static/media/productplaceholder.5f126f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productplaceholder.png
// module id = 154
// module chunks = 0